// CSS-based ellipsis loader
const ButtonLoader = ({ className }: { className?: string }) => (
  <div
    className={`flex space-x-1 justify-center items-center ${className || ''}`}
  >
    <div className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:-0.3s]"></div>
    <div className="w-2 h-2 bg-current rounded-full animate-bounce [animation-delay:-0.15s]"></div>
    <div className="w-2 h-2 bg-current rounded-full animate-bounce"></div>
  </div>
);

export function EllipsisLoader(props: { className?: string }) {
  return <ButtonLoader {...props} />;
}
